import { Contract } from '@ecm/portfolio';

import { StatusEnum } from '../business/api/contract/status.enum';
import { ClientTypeEnum } from '../business/api/dashboard/forbidden/clientType.enum';

export const DashboardContainerComponentHelpers = {
    getForbiddenType: (contract: Contract): ClientTypeEnum => {
        let clientType: ClientTypeEnum;
        if (contract.telco?.state === ClientTypeEnum.SUGGESTED) {
            clientType = ClientTypeEnum.SUGGESTED;
        } else if (contract.security) {
            clientType = ClientTypeEnum.PROTECTEDHOUSE;
        } else if (contract.status === StatusEnum.TERMINATED || contract.status === StatusEnum.CLOSED) {
            clientType = ClientTypeEnum.TERMINATED;
        }
        return clientType;
    },

    isForbiddenContract: (contract: Contract): boolean => {
        return !!(
            (contract.telco && contract.telco.state === ClientTypeEnum.SUGGESTED) ||
            contract.security ||
            contract.status === StatusEnum.TERMINATED ||
            contract.status === StatusEnum.CLOSED
        );
    },
};
